import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'arm-pcons-search',
  templateUrl: './pcons-search.component.html',
  styleUrls: ['./pcons-search.component.scss']
})
export class PconsSearchComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<PconsSearchComponent>,@Inject(MAT_DIALOG_DATA) public search: any) { }

  onApply = new EventEmitter();

  ngOnInit(): void {
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    this.dialogRef.close();
    this.onApply.emit(this.search);
  }
}
